import Texte from "../../components/Texte/texte";
import "../Services/services.css"

function Service () {
return(<div className="service-background">
    < Texte />
</div>)
}

export default Service